import React from 'react';
import { Facebook, Instagram, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#084A70] text-white/80 py-12 border-t border-white/10" data-id="element-159" data-mp="3gfsoch60l2p3">
      <div className="container mx-auto px-4" data-id="element-160" data-mp="32nuhkczrziw3">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-161" data-mp="32p5qssbzpiul">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-162" data-mp="36q953aee36tp">
            <a href="#" className="inline-block mb-6" data-id="element-163" data-mp="3ufa4671c15mb">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m3nP7fc9XV1ZSHtYcih2QJ/Beach_Club_Logo.png" alt="Beach Club Logo" className="h-20 w-20 object-cover rounded-full border-2 border-white/20" data-id="element-164" data-mp="3ufjvbxy45itl" />
            </a>
            <p className="text-sm leading-relaxed mb-6" data-id="element-165" data-mp="3lgon6gbidynn">
              מועדון הגלישה והחתירה המוביל בכנרת. מקצועיות, בטיחות ואהבה לים הם
              הערכים שמובילים אותנו.
            </p>
            <div className="flex gap-4" data-id="element-166" data-mp="2a19uvpu8vuyv">
              <a href="#" className="hover:text-white transition-colors bg-white/5 p-2 rounded-full hover:bg-white/20" data-id="element-167" data-mp="2eyjrpqjyr8wq">
                <Facebook className="w-5 h-5" data-id="element-168" data-mp="3labovo69tsmo" />
              </a>
              <a href="#" className="hover:text-white transition-colors bg-white/5 p-2 rounded-full hover:bg-white/20" data-id="element-169" data-mp="3gapfjptkcwj5">
                <Instagram className="w-5 h-5" data-id="element-170" data-mp="3v8rhxwouzbyt" />
              </a>
              <a href="#" className="hover:text-white transition-colors bg-white/5 p-2 rounded-full hover:bg-white/20" data-id="element-171" data-mp="3q8n0o4g4md7j">
                <Youtube className="w-5 h-5" data-id="element-172" data-mp="82ihe6dukyl6" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-173" data-mp="335slg3f1hfy">
            <h4 className="text-white font-bold mb-6" data-id="element-174" data-mp="33e3x3jw4ep1">ניווט מהיר</h4>
            <ul className="space-y-3 text-sm" data-id="element-175" data-mp="ht3dnn61tr0x">
              <li data-id="element-176" data-mp="huwlv6wb8jb1">
                <a href="/" className="hover:text-white transition-colors" data-id="element-177" data-mp="ctqrz5qwypzx">
                  דף הבית
                </a>
              </li>
              <li data-id="element-178" data-mp="qub81u5g27pq">
                <a href="/sup" className="hover:text-white transition-colors" data-id="element-179" data-mp="qtrpcb7yzfan">
                  SUP
                </a>
              </li>
              <li data-id="element-180" data-mp="tvcz5qtmo3em">
                <a href="/sup-race" className="hover:text-white transition-colors" data-id="element-181" data-mp="tvw6yepkdbex">
                  SUP Race
                </a>
              </li>
              <li data-id="element-182" data-mp="ys3f8e5fmz01">
                <a href="/sup-tours" className="hover:text-white transition-colors" data-id="element-183" data-mp="13tam8azr3u5n">
                  טיולי סאפ
                </a>
              </li>
              <li data-id="element-184" data-mp="18ksmsxxv3sq3">
                <a href="/surfski" className="hover:text-white transition-colors" data-id="element-185" data-mp="18lbvdo1mh4rg">
                  קיאק Surfski
                </a>
              </li>
              <li data-id="element-186" data-mp="1hk5vvpi2qfaa">
                <a href="/wingfoil" className="hover:text-white transition-colors" data-id="element-187" data-mp="1hje2mlby8tn6">
                  Wing Foil
                </a>
              </li>
              <li data-id="element-188" data-mp="1riv6cx7n4xgi">
                <a href="/events" className="hover:text-white transition-colors" data-id="element-189" data-mp="1rjeqmkkrjxxp">
                  אירועים וסדנאות
                </a>
              </li>
              <li data-id="element-190" data-mp="3oczot9hfgf5i">
                <a href="/#contact" className="hover:text-white transition-colors" data-id="element-191" data-mp="3odhs2q2ibtmx">
                  צור קשר
                </a>
              </li>
            </ul>
          </div>

          {/* Activities */}
          <div data-id="element-192" data-mp="25oexs0w4xofq">
            <h4 className="text-white font-bold mb-6" data-id="element-193" data-mp="25nvh0ni8163a">פעילויות</h4>
            <ul className="space-y-3 text-sm" data-id="element-194" data-mp="25mkcumkv5wbn">
              <li data-id="element-195" data-mp="21nv4x9ilh6ze">
                <a href="#" className="hover:text-white transition-colors" data-id="element-196" data-mp="21nbjvjxne2h5">
                  שיעורי גלישה
                </a>
              </li>
              <li data-id="element-197" data-mp="2tdpth3ymosn0">
                <a href="#" className="hover:text-white transition-colors" data-id="element-198" data-mp="2te9cyp3xfp35">
                  השכרת ציוד
                </a>
              </li>
              <li data-id="element-199" data-mp="2pd5v5x2bjiza">
                <a href="#" className="hover:text-white transition-colors" data-id="element-200" data-mp="2pajsobuabtnx">
                  קבוצות חתירה
                </a>
              </li>
              <li data-id="element-201" data-mp="2fd5ao7spqwti">
                <a href="#" className="hover:text-white transition-colors" data-id="element-202" data-mp="2fdosloid5l7j">
                  אירועים פרטיים
                </a>
              </li>
              <li data-id="element-203" data-mp="13zb8muqqdpws">
                <a href="#" className="hover:text-white transition-colors" data-id="element-204" data-mp="13ys1m92mclxj">
                  ימי גיבוש
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div data-id="element-205" data-mp="2wmpo2fo6voj4">
            <h4 className="text-white font-bold mb-6" data-id="element-206" data-mp="2wn97y1xegmzs">הישארו מעודכנים</h4>
            <p className="text-sm mb-4" data-id="element-207" data-mp="2ivkvtyn5hyit">
              הירשמו לניוזלטר שלנו לקבלת עדכונים על אירועים ומבצעים
            </p>
            <form className="flex gap-2" data-id="element-208" data-mp="2nuxm6td8dnq5">
              <input type="email" placeholder="האימייל שלך" className="bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-sm text-white placeholder-white/50 focus:outline-none focus:border-white w-full" data-id="element-209" data-mp="2nrrxvgcfepvh" />
              <button className="bg-white text-[#084A70] px-4 py-2 rounded-lg text-sm font-bold hover:bg-blue-50 transition-colors" data-id="element-210" data-mp="31lsv25nqc4tq">
                שלח
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8" data-id="element-211" data-mp="1q64658qx0vqa">
          <div className="text-center text-xs" data-id="element-212" data-mp="1q8qf9ctgfjam">
            <p data-id="element-213" data-mp="1v6i4fz2psrb4">
              &copy; {new Date().getFullYear()} Beach Club Maagan Eden. כל
              הזכויות שמורות.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}